import React, { Fragment, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PieChart = (props) => {
    let { dashboard, data } = props;
    let dashboardType = parseInt(dashboard[2]);
    let dashboardName = dashboard[1];
    let piechartdata = [];
    for (let i = 0; i < data[2].length; i++) {
        let paramstr = {name: data[2][i][0]+"  "+parseInt(data[2][i][1], 10).toLocaleString()+"  ",y: parseInt(data[2][i][1], 10)};
        piechartdata.push(paramstr);
    }
    let options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: ""
        },
        tooltip: {
            pointFormat: ' <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: false
            }
        },
        credits:{
	    	enabled: false
	    },
        series: [{
	        name: dashboardName,
	        colorByPoint: true,
	        data: piechartdata
	    }],
    }
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
};

export default PieChart;